import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }

import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import citydata from '@/assets/js/citydata'
  import { ElMessage, ElLoading } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  setup(__props) {

  const router = useRouter()
  const route = useRoute()
  const baseData:any = reactive({
    citydata : [],
    supplierList : [],
  })
  const props = {
    expandTrigger: 'hover',
    children: 'cityArr',
    label: 'Name',
    value: 'Code',
  }
  const form:any = reactive({
    id: '',
    supplierid:'',
    secSupplierid:'',
    sn: '',
    goods_name: '',
    goods_id: '',
    number: '',
    appointmentDate: '',
    appointmentTime: '',
    goods:[],
    finalAppointmentDate: '',
    finalAppointmentTime: '',
    name: '',
    mobile: '',
    address: '',
    areas: [],
    province: '',
    city: '',
    area: '',
    star:0,
    evaluate:'',
    dremark:'',
    dimgs:'',
    daddTime:'',
    refuseReason: '',
    receiveTime: '',
    refuseTime: '',
    finishTime: '',
    status: 0,
  })
  const changeAreas = () => {
    form.province = form.areas[0]
    form.city = form.areas[1]
    form.area = form.areas[2]
  }
  const get = () => {
    const loading = ElLoading.service({lock: true})
    api.orderApi.get({id:route.params.id}).then((res:any)=>{
      if(res.code==200){
        form.supplierid = res.data.supplierid ? res.data.supplierid : ''
        form.secSupplierid = res.data.secSupplierid
        form.sn = res.data.sn
        form.goods_name = res.data.goods_name
        form.goods_id = res.data.goods_id
        form.number = res.data.number
        form.appointmentTime = res.data.appointmentTime
        form.goods = res.data.goods
        form.appointmentDate = res.data.appointmentDate
        form.finalAppointmentTime = res.data.finalAppointmentTime
        form.finalAppointmentDate = res.data.finalAppointmentDate
        form.name = res.data.name
        form.mobile = res.data.mobile
        form.address = res.data.address
        form.areas = res.data.areas
        form.province = res.data.province
        form.city = res.data.city
        form.area = res.data.area
        form.refuseReason = res.data.refuseReason
        form.dremark = res.data.dremark
        form.dimgs = res.data.dimgs
        form.daddTime = res.data.daddTime
        form.star = res.data.star
        form.evaluate = res.data.evaluate
        form.receiveTime = res.data.receiveTime
        form.refuseTime = res.data.refuseTime
        form.finishTime = res.data.finishTime
        form.status = res.data.status
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const onSubmit = () => {
    const loading = ElLoading.service({lock: true})
    if(!form.supplierid){
      ElMessage.error('请选择合适的服务商')
      loading.close()
      return false
    }
    api.orderApi.save(form).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/workOrder");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getSupplierList = () => {
    api.supplierApi.alllist({}).then((res:any)=>{
      if(res.code==200){
        baseData.supplierList = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  onMounted(() => {
    baseData.citydata = citydata.provinceArr
    form.id = route.params.id
    get()
    getSupplierList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/workOrder' } }, {
              default: _withCtx(() => [
                _createTextVNode("工单列表")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("编辑工单")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "180px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "服务商" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: form.supplierid,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.supplierid) = $event)),
                  placeholder: "请选择合适的服务商",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.supplierList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.company,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "工单编号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(form.sn), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "商品信息" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: form.goods,
                  border: "",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "catagory_name",
                      label: "分类",
                      width: "120"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "goods_name",
                      label: "名称"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "proId",
                      label: "商品ID"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "number",
                      label: "数量",
                      width: "80"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "addTime",
                      label: "时间",
                      width: "170"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "上门时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(form.appointmentDate) + " " + _toDisplayString(form.appointmentTime), 1)
              ]),
              _: 1
            }),
            (form.finalAppointmentTime)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "最终确认上门时间"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.finalAppointmentDate) + " " + _toDisplayString(form.finalAppointmentTime), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "联系人" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.name) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.mobile,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.mobile) = $event)),
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: form.areas,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.areas) = $event)),
                  filterable: "",
                  options: baseData.citydata,
                  props: props,
                  onChange: changeAreas
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "详细地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.address,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.address) = $event)),
                  maxlength: "250",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (form.status == 8)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "拒单原因"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.refuseReason), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 8)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "拒单时间"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.refuseTime), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 2 || form.status == 3 || form.status == 4)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "接单时间"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.receiveTime), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 4)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 4,
                  label: "完成时间"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.finishTime), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 5||form.status == 6)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 5,
                  label: "核销备注"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.dremark), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 5||form.status == 6)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 6,
                  label: "核销附件"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.dimgs, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_image, {
                        key: index,
                        style: {"width":"100px","height":"100px"},
                        src: item,
                        "preview-src-list": form.dimgs
                      }, null, 8, ["src", "preview-src-list"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 5||form.status == 6)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 7,
                  label: "核销时间"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.daddTime), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 5)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 8,
                  label: "评价"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_rate, {
                      modelValue: form.star,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.star) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (form.status == 5)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 9,
                  label: "评价"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(form.evaluate), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: 1,
                      disabled: "form.status >3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("待接单")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 2,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("已接单")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 3,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("安装中")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 4,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("待核销")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 6,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("待评价")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 5,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("已完成")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 8,
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("已拒单")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: goBack }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})